import { render, staticRenderFns } from "./EditCoupon.vue?vue&type=template&id=fcaba0bc&scoped=true&"
import script from "./EditCoupon.vue?vue&type=script&lang=ts&"
export * from "./EditCoupon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcaba0bc",
  null
  
)

export default component.exports